import React from 'react';

const HomeIcon = ({ active }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className={active}>
      <mask id="mask0_13923_28466" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" />
      </mask>
      <g mask="url(#mask0_13923_28466)">
        <path d="M4.5 20.5V9.24999L12 3.60574L19.5 9.24999V20.5H13.9038V13.8077H10.0963V20.5H4.5Z" />
      </g>
    </svg>
  );
};

export default HomeIcon;
